import { FormatRegistry } from "@sinclair/typebox";
/**
 * TypeBox knows no formats until they are registered, and an unregistered
 * format silently fails every check. Defining them here means the boundary
 * validator, the tests and the OpenAPI document all agree on what a `uuid` is
 * instead of each deciding separately.
 *
 * Importing this module registers them. `registerFormats` is exported for
 * callers that would rather be explicit.
 */
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
/** RFC 3339 date-time. Offset or `Z` is required — a local timestamp is ambiguous. */
const DATE_TIME = /^\d{4}-\d{2}-\d{2}[Tt]\d{2}:\d{2}:\d{2}(\.\d+)?([Zz]|[+-]\d{2}:\d{2})$/;
export function registerFormats() {
    if (!FormatRegistry.Has("uuid")) {
        FormatRegistry.Set("uuid", (value) => UUID.test(value));
    }
    if (!FormatRegistry.Has("date-time")) {
        FormatRegistry.Set("date-time", (value) => DATE_TIME.test(value) && !Number.isNaN(Date.parse(value)));
    }
}
registerFormats();
//# sourceMappingURL=formats.js.map